import request from '@/util/request';

// 分页
export const getPageListApi = (params, options) =>
  request.get('/api/v4ward/callcenter/repository/faq/page', Object.assign({}, options, { params }));
